import type {Agent} from '../types';

export const removeMentionedIn = (agent: Agent) => {
  const newLinks = agent.links?.filter(
    link => link.role !== 'mentionedIn.work',
  );

  return {
    ...agent,
    links: newLinks,
  };
};
